// extracted by mini-css-extract-plugin
module.exports = {"ListAndImage":"HowItWorksSection-module__ListAndImage___2bxet"};